import React, { useLayoutEffect, FC } from 'react';
import { CookieWall, CookieConsent } from '@takeaway/ui-vanilla';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useCurrentUserActions, useCurrentUserState } from '@src/shared/context/current-user';
import i18n from '@src/i18n';
import MCPMarketEnvironmentDetection from '@src/shared/utils/market-environment-detection';

export const CookieBanner: FC = () => {
  const { countryCode }: { countryCode: any } =
    MCPMarketEnvironmentDetection.getMarketEnvironment();
  const classes = useStyles();
  const { t } = useTranslation();
  const { isConsentBannerActive } = useCurrentUserState();
  const { setIsConsentBannerActive } = useCurrentUserActions();
  const updateCookieFn = (cookieConsent: string) => {
    if (CookieConsent.getConsent() === 'temporary' || cookieConsent === 'temporary') {
      Cookies.remove('cookieConsent');
      return setIsConsentBannerActive(true);
    }

    return setIsConsentBannerActive(false);
  };

  useLayoutEffect(() => {
    try {
      new CookieWall({
        classList: [classes.cookieWallContainer],
        $container: document.getElementById('cookieWall'),
        contentText: t('legals.consent_banner_text'),
        url: '/cookie-statement',
        urlText: t('legals.consent_banner_preference'),
        buttonText: t('legals.consent_banner_button'),
        domain: MARKET_URLS[countryCode],
        updateCookieFn,
      });
    } catch (e) {
      console.log(e);
    }
  }, [isConsentBannerActive, i18n.language]);

  return <div id="cookieWall" className={classes.root} />;
};

export default CookieBanner;
